<div class="status-change-notifications">
    <on-off-toggle [class.left-offset]="showStatusCheckboxes" [active]="!dataOutOfDate" [boolValue]="settings?.statusChange"
        (onChange)="toggleEnableNotification($event)"></on-off-toggle>
    @if (showStatusCheckboxes) {
<form class="status-settings">
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="Attention Needed" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.attentionNeeded" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.AttentionNeeded)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="Approved" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.approved" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.Approved)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="In Transit" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.inTransit" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.InTransit)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="Completed" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.completed" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.Completed)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="WeeklyPlannedRequest" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.weeklyPlannedRequest" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.WeeklyPlannedRequest)}}
            </label>
            <span class="info ups-icon ups-icon-informationcircle" title="{{localize(langSection.NotificationSettings, langText.WeeklyPlannedRequestInfo)}}">
            </span>
                </div>
         <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="Pending" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.pending" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.Pending)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="Scheduled" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.scheduled" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.Scheduled)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="On Property" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.onProperty" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.OnProperty)}}
            </label>
        </div>
        <div class="form-check">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" name="Canceled" [disabled]="dataOutOfDate"
                    [(ngModel)]="settings.statusChangeNotifications.canceled" (change)="onCheckChanged()">
                <span class="checkbox" [class.disabled]="dataOutOfDate"></span>
                {{localize(langSection.NotificationSettings, langText.Canceled)}}
            </label>
        </div>
   </form>
}
</div>